export const defaultLabels = {
  email: "Email address",
  password: "Password",
  LOGIN_ROUTE: '/login'
};

export const loginType = {
  phone: "phone",
  email: "email",
};

/** Amplitude "Sign In Method" values; keys match {@link loginType} values. */
export const amplitudeSignInMethodByLoginType = {
  [loginType.phone]: "Phone",
  [loginType.email]: "Email",
};

